import { openapi } from "../../../../openapi";
import type {
  GetProjectByProjectIdChecklistAndChecklistIdPartsApiResponse,
  GetProjectByProjectIdChecklistAndChecklistIdPartsApiArg,
} from "../../../../openapi";

type ChecklistPartsDraft = GetProjectByProjectIdChecklistAndChecklistIdPartsApiResponse;
type ChecklistPartsArg = GetProjectByProjectIdChecklistAndChecklistIdPartsApiArg;
type ChecklistItemWithProgress = NonNullable<ChecklistPartsDraft["items"]>[number] & {
  progress?: NonNullable<ChecklistPartsDraft["checklist"]>["progress"];
};

const getChecklistPartsArg = (arg: ChecklistPartsArg): ChecklistPartsArg => ({
  projectId: arg.projectId,
  checklistId: arg.checklistId,
});

const patchChecklistParts = (dispatch: any, arg: ChecklistPartsArg, recipe: (draft: ChecklistPartsDraft) => void) => {
  dispatch(
    openapi.util.updateQueryData(
      "getProjectByProjectIdChecklistAndChecklistIdParts",
      getChecklistPartsArg(arg),
      recipe,
    ),
  );
};

openapi.enhanceEndpoints({
  endpoints: {
    getProjectByProjectIdChecklistAndChecklistIdParts: {
      providesTags: ["Checklist"],
    },
    putProjectByProjectIdChecklistAndChecklistId: {
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          patchChecklistParts(dispatch, arg, (draft) => {
            draft.checklist = data;
          });
        } catch {
          // no-op: leave cache untouched on failed update
        }
      },
    },
    putProjectByProjectIdChecklistAndChecklistIdCategoryCategoryId: {
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          patchChecklistParts(dispatch, arg, (draft) => {
            const categoryIndex = draft.categories.findIndex((category) => category._id === data._id);
            if (categoryIndex !== -1) {
              draft.categories[categoryIndex] = data;
            }
          });
        } catch {
          // no-op: leave cache untouched on failed update
        }
      },
    },
    putProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdInactive: {
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          patchChecklistParts(dispatch, arg, (draft) => {
            Object.assign(draft, data);
          });
        } catch {
          // no-op: leave cache untouched on failed toggle
        }
      },
    },
    putProjectByProjectIdChecklistAndChecklistIdItemItemId: {
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          patchChecklistParts(dispatch, arg, (draft) => {
            const { progress, ...updatedItem } = data as ChecklistItemWithProgress;
            const itemIndex = draft.items.findIndex((item) => item._id === data._id);

            if (itemIndex !== -1) {
              draft.items[itemIndex] = updatedItem;
            }

            if (draft.checklist != null && progress != null) {
              draft.checklist.progress = progress;
            }
          });
        } catch {
          // no-op: leave cache untouched on failed update
        }
      },
    },
    getChecklistsByReviewByReviewId: {
      providesTags: ["Checklist"],
    },
    putChecklistsByChecklistIdDkApprovalToggle: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(openapi.util.invalidateTags(["Checklist"]));
        } catch {
          // no-op: leave cache untouched on failed toggle
        }
      },
    },
  },
});
